<script lang="ts">
  import { createContext } from 'reka-ui'
  import type { TenantOwnedDatabasesService } from '@gat-ship/types/injection-keys'

  const [useTenantOwnedDatabases, provideTenantOwnedDatabases] =
    createContext<TenantOwnedDatabasesService>(
      'tenant-owned-databases-provider'
    )
  export { useTenantOwnedDatabases }
</script>

<script setup lang="ts">
  import { inject, onMounted, provide } from 'vue'
  import { useTenantOwnedDatabases as useTenantOwnedDatabasesDataSource } from '../../composables/useTenantOwnedDatabases'
  import { tenantOwnedDatabasesKey } from '@gat-ship/types/injection-keys'

  const props = withDefaults(
    defineProps<{
      /** @default true */
      fetchOnMount?: boolean
    }>(),
    {
      fetchOnMount: true
    }
  )

  onMounted(() => {
    if (props.fetchOnMount) {
      dataSource.fetchData()
    }
  })

  const dataSource =
    inject(tenantOwnedDatabasesKey, undefined) ??
    useTenantOwnedDatabasesDataSource()
  provide(tenantOwnedDatabasesKey, dataSource)
  provideTenantOwnedDatabases(dataSource)
</script>
<template>
  <slot />
</template>
